/*
 * @Author: hanchunxuan 1627047609@qq.com
 * @Date: 2023-10-08 09:23:08
 * @LastEditors: hanchunxuan 1627047609@qq.com
 * @LastEditTime: 2023-10-14 10:07:52
 * @FilePath: \1008\zonghoutai-front\src\api\http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import base  from './base'
import axios from '../axios/request'

const  http= {
    test:function (){
        return axios.get('/api/apiTest/apiget')
    },
    getCodeImg:function(){
        return axios.get(base.captchaImage)
    },
    login:function(params){
        return axios.post(base.login,params)
    },
    logout:function(params){
        return axios.post(base.logout,params)
    },
    userInfo:function(){
        return axios.get(base.getInfo)
    },
    userList:function(params){
        console.log(params);
        return axios.get(base.userList,{params})
    },
    getUser:function(params){
        return axios.get(base.getUser,{params})
    },
    addUser:function(params){
        return axios.post(base.addUser,params)
    },
    updateUser:function(params){
        return axios.put(base.updateUser,{params})
    },
    //获取总站信息-总站id
    getSonStation:function(id){
        return axios.get(base.getSonStation+'?fromTotal='+id)
    },
    //获取总站列表-userId
    getStationList:function(id){
        return axios.get(base.getStationList+'/'+id)
    },
    // getAllStationPublic,getObtainAccess,getRetrieve
    //获取总站发布
    getAllStationPublic:function(id){
        return axios.get(base.getAllStationPublic+'?userId='+id)
    },
	getPublishedPages:function(id){
	    return axios.get(base.getPublishedPages+'?userId='+id)
	},
    //获取总站访问
    getObtainAccess:function(id){
        return axios.get(base.getObtainAccess+'?userId='+id)
    },
    //获取总站浏览
    getRetrieve:function(id){
        return axios.get(base.getRetrieve+'?userId='+id)
    },
    //获取短视频播放量
    getVideoPlay:function(id){
        return axios.get(base.getVideoPlay+'?userId='+id)
    },
    //获取短视频播放量
    getVideoFans:function(id){
        return axios.get(base.getvideoFans+'?userId='+id)
    },
    //获取短视频播放量
    getVideoRelease:function(id){
        return axios.get(base.getvideoRelease+'?userId='+id)
    },
    getExposureFromUserId:function(id){
        return axios.get(base.getExposureFromUserId+'?userId='+id)
    },
    getTikTokStationJoinSysUser:function(id){
        return axios.get(base.getTikTokStationJoinSysUser+'?userId='+id)
    },

    worldMapInfos:function(url){
        return axios.get(base.worldMapInfos+'?mainStationUrl='+url)
    },
	//免密登录
	doLogin:function(params){
		return axios.post(base.doLogin,params)
	}
 
}
export default  http// 获取验证码


// // 查询角色列表
// export function listRole(query) {
//   return request({
//     url: '/system/role/list',
//     method: 'get',
//     params: query
//   })
// }

// // 查询角色详细
// export function getRole(roleId) {
//   return request({
//     url: '/system/role/' + roleId,
//     method: 'get'
//   })
// }

// // 新增角色
// export function addRole(data) {
//   return request({
//     url: '/system/role',
//     method: 'post',
//     data: data
//   })
// }

// // 修改角色
// export function updateRole(data) {
//   return request({
//     url: '/system/role',
//     method: 'put',
//     data: data
//   })
// }

// // 角色数据权限
// export function dataScope(data) {
//   return request({
//     url: '/system/role/dataScope',
//     method: 'put',
//     data: data
//   })
// }

// // 角色状态修改
// export function changeRoleStatus(roleId, status) {
//   const data = {
//     roleId,
//     status
//   }
//   return request({
//     url: '/system/role/changeStatus',
//     method: 'put',
//     data: data
//   })
// }

// // 删除角色
// export function delRole(roleId) {
//   return request({
//     url: '/system/role/' + roleId,
//     method: 'delete'
//   })
// }

// // 查询角色已授权用户列表
// export function allocatedUserList(query) {
//   return request({
//     url: '/system/role/authUser/allocatedList',
//     method: 'get',
//     params: query
//   })
// }

// // 查询角色未授权用户列表
// export function unallocatedUserList(query) {
//   return request({
//     url: '/system/role/authUser/unallocatedList',
//     method: 'get',
//     params: query
//   })
// }

// // 取消用户授权角色
// export function authUserCancel(data) {
//   return request({
//     url: '/system/role/authUser/cancel',
//     method: 'put',
//     data: data
//   })
// }

// // 批量取消用户授权角色
// export function authUserCancelAll(data) {
//   return request({
//     url: '/system/role/authUser/cancelAll',
//     method: 'put',
//     params: data
//   })
// }

// // 授权用户选择
// export function authUserSelectAll(data) {
//   return request({
//     url: '/system/role/authUser/selectAll',
//     method: 'put',
//     params: data
//   })
// }

// // 根据角色ID查询部门树结构
// export function deptTreeSelect(roleId) {
//   return request({
//     url: '/system/role/deptTree/' + roleId,
//     method: 'get'
//   })
// }
